import { create } from 'zustand';

import { isJsonSchema7 } from '@/components/SchemaEditor/JsonSchema.guard';
import { DatasetSchema, DatasetTransformationSchema } from '@/types/schema';

export const useDatasetSchemaStore = create<{
  inputSchema: Record<string, unknown> | null;
  setInputSchema: (inputSchema: Record<string, unknown> | null) => void;
  outputSchema: Record<string, unknown> | null;
  setOutputSchema: (outputSchema: Record<string, unknown> | null) => void;
  transformations: DatasetTransformationSchema[] | undefined;
  setTransformations: (
    transformations: DatasetTransformationSchema[] | undefined
  ) => void;
  error: string | undefined;
  setError: (error: string | undefined) => void;
  reset: (dataset?: DatasetSchema) => void;
}>((set, get) => ({
  inputSchema: {},
  setInputSchema: (inputSchema) => {
    if (!inputSchema || isJsonSchema7(inputSchema)) {
      const existingError = get().error;
      return set({
        inputSchema,
        error: existingError?.includes('Input') ? undefined : existingError,
      });
    }
    return set({
      inputSchema,
      error: 'Input schema is not a valid JSON schema',
    });
  },
  outputSchema: {},
  setOutputSchema: (outputSchema) => {
    if (!outputSchema || isJsonSchema7(outputSchema)) {
      const existingError = get().error;
      return set({
        outputSchema,
        error: existingError?.includes('Output') ? undefined : existingError,
      });
    }
    return set({
      outputSchema,
      error: 'Output schema is not a valid JSON schema',
    });
  },
  transformations: [],
  setTransformations: (transformations) => {
    return set({
      transformations,
    });
  },
  error: undefined,
  setError: (error) => set({ error }),
  reset: (dataset) => {
    set({
      inputSchema: dataset?.inputs_schema_definition,
      outputSchema: dataset?.outputs_schema_definition,
      transformations: dataset?.transformations,
    });
  },
}));
